window.reInitSwiperOnProductRecommendation = function(main_wrapper){
    if(main_wrapper){
        const related_product_swiper = main_wrapper.querySelector('.related-products-swiper');
        if(related_product_swiper){
            new Swiper(related_product_swiper, {
                slidesPerView: 4,
                spaceBetween: 20,
                loop: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                breakpoints: {
                    0: { slidesPerView: 1.2 },
                    480: { slidesPerView: 2 },
                    768: { slidesPerView: 3 },
                    1024: { slidesPerView: 4 },
                },
            });
        }
    }
}


document.addEventListener("DOMContentLoaded", function () {
document.querySelectorAll("div").forEach(function (div) {
    // Trim inner text and check if it’s truly empty (no text, no children)
    if (!div.textContent.trim() && div.children.length === 0) {
    div.classList.add("hide_div");
    }
});
});
